export function setSectionVisibility(section, isVisible) {
  return {
    type: 'SET_SECTION_VISIBILITY',
    section,
    isVisible
  }
}

export function setParticleVisibility (section, config, visible) {
  return {
    type: 'SET_PARTICLE_VISIBILITY',
    section,
    config,
    visible
  }
}

export function setSectionProperty (section, config, value) {
  return {
    type: 'SET_SECTION_PROPERTY',
    section,
    config,
    value
  }
}


// WEBPACK FOOTER //
// ./src/actions/sections/SectionsActions.js